export default "__VITE_ASSET__7004bff9__"